import React, { Component } from 'react';
import {Query} from 'react-apollo';
import gql from 'graphql-tag';
import Spinner from '../../../components/spinner/spinner';
import ScrollToTop from '../../../components/ScrollToTop/ScrollToTop';
import ToolTopper from '../Tools/sections/tool_topper/tool_topper';
import ToolSection from '../Tools/sections/tool_section/tool_section';
import { Helmet } from 'react-helmet';
import styles from './Tools.module.scss';

export default class Tools extends Component {

  componentDidMount() {


  }

  render() {

    const SECTIONS_QUERY = gql`query sectionNames {
      pages (where: { page_name: "tools" }) {
        sections {
          components {
            component_name
          }
        }
      }
    }`;

    return (

    <Query query={SECTIONS_QUERY}>
      {({ loading, error, data }) => {
        if (loading) return <Spinner />
        if (error) return `Error! ${error.message}`;

        // WIP to call components based on returned GQL data

        // const section_names = {}

        // data.sections.forEach(section => {
        //   let section_name = section.section_name;
        //   let upper_name = section_name.charAt(0).toUpperCase() + section_name.slice(1);
        //   let section_value = {upper_name}
        //   section_names[section_name] = section_value;
        // })



        // const sections = data.sections.map(section => {
        //   const Section = section_names[section.section_name];
        //   return(
        //     <Section />
        //   )
        // });


        return (
        <div className={styles.mainWindow}>
          <Helmet>
            <title>Tools and Accessories | Texacone</title>
            <meta name="description" content="Popular Elevator Accessories to get the job done including Packing Replacement kit, Sanding Sleeve, Sure Fill Repair Kit, Aligning System, Jack's Green Slime, and Head ID Handbook." />
          </Helmet>
          <ScrollToTop />
          <div className={styles.sectionWrapper}>
            <ToolTopper />
            <ToolSection />
          </div>
        </div>
        );
      }}
    </Query>
    )
  };
}
